'use client';

import React from 'react';
import NextLink from 'next/link';
import type { ComponentProps, MouseEventHandler, ReactNode } from 'react';
import { nextLinkPrefetch, shouldHardNavigateProductApp } from '@/platform/lib/nextPrefetch';

type Props = {
  href: string;
  children: ReactNode;
  className?: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  role?: string;
  'aria-label'?: string;
  'data-testid'?: string;
  prefetch?: ComponentProps<typeof NextLink>['prefetch'];
};

/**
 * Same-origin nav for Communio product Hosting. Uses a real `<a>` so the browser
 * stays on the current host (`{slug}.communiosocial.com`) instead of App Router
 * soft-nav / RSC fetches that can resolve against baked apex `SITE_URL`.
 */
export function ProductNavLink({ href, children, className, onClick, prefetch, ...rest }: Props) {
  if (shouldHardNavigateProductApp() && href.startsWith('/')) {
    return (
      <a href={href} className={className} onClick={onClick} {...rest}>
        {children}
      </a>
    );
  }
  return (
    <NextLink
      href={href}
      className={className}
      onClick={onClick}
      prefetch={prefetch ?? nextLinkPrefetch()}
      {...rest}
    >
      {children}
    </NextLink>
  );
}
